module.exports = __webpack_public_path__ + "static/media/flyer2-text.052f1bfb.png";